import React, { useEffect, useState, useRef } from "react";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.css";
import "froala-editor/js/plugins.pkgd.min.js";
import { useHistory, useParams } from "react-router-dom";
import BannerPreviewHeader from "../../components/Editor/BannerPreviewHeader";
import { Container } from "react-bootstrap";
import BannerConfirmationModal from "../../components/BannerManager/BannerConfirmationModal";
import BannerStaticConfirmation from "../../components/BannerManager/BannerStaticConfirmation";
import {
  getAssetsData,
  getAssetsDataTrackChanges,
  getMLRstatus,
  getSaveAssets,
  getBackupImageSettings,
  veevaPublish,
} from "../../services/apis";
import {
  generateTrackChangesHtml,
  generateTrackHtml,
  emitter,
  NO_PREVIEW_BASE64,
  extractBackupImageData,
} from "../../Uitls/Util";
import { toast } from "react-toastify";
import { Tabs, Tab, CircularProgress } from "@mui/material";
import RSDImageOTC from "../../../src/images/rsdJourneyOTC.svg";
import RSDImageDoneOTC from "../../../src/images/rsdJourneyCompleteOTC.svg";
import Frame from "./Frames";
import { convertTextToBullets } from "../../Uitls/EditorUtil";
import { isDisabled } from "../../Uitls/veeva";

const PreviewBanner = () => {
  const [descriptions, setDescriptions] = useState({});
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showStaticModal, setShowStaticModal] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const history = useHistory();
  const { bannerId } = useParams();
  const [additionalProps, setAdditionalProps] = useState(null);
  const [loading, setLoading] = useState(false);
  const [assetData, setAssetData] = useState([]);
  const [selectedFramesPerTab, setSelectedFramesPerTab] = useState({});
  const [bannerName, setBannerName] = useState("Banner Preview");
  const [tabDescriptions, setTabDescriptions] = useState({});
  const [currentMLRStatus, setcurrentMLRStatus] = useState("Not Submitted");
  const [market, setmarket] = useState("");
  const [isAnimated, setisAnimated] = useState(false);
  const [noScreensShotsAvailable, setnoScreensShotsAvailable] = useState(false);
  const [tabTrackChanges, setTabTrackChanges] = useState({});
  const [tabSelected, setTabSelected] = useState(1);

  const getLatestMLRStatus = async (id) => {
    try {
      const response = await new Promise((resolve, reject) => {
        getMLRstatus(id, (data, err, errorCode) => {
          if (err) {
            reject("Not Submitted");
          } else {
            resolve(data?.data?.mlrStatus || "Not Submitted");
          }
        });
      });

      setcurrentMLRStatus(response);
      return response;
    } catch (error) {
      setcurrentMLRStatus("Not Submitted");
      return "Not Submitted";
    }
  };
  const normalizeDocId = (docId) => {
    if (docId === null || docId === undefined) return "";
    const normalized = String(docId).trim().toUpperCase();
    return normalized && normalized !== "-" ? normalized : "";
  };

  useEffect(() => {
    const handleMLRStatusUpdate = (data) => {
      const currentDocId = normalizeDocId(bannerId);
      const eventDocIds = [
        data?.damDocNumber,
        data?.documentNumber,
        data?.veevaDocNumber,
        data?.elementName,
        data?.damDocId,
        data?.documentId,
        data?.id,
      ].map((value) => normalizeDocId(value));

      if (!currentDocId || !eventDocIds.includes(currentDocId)) return;

      const nextStatus =
        data?.mlrStatus || data?.reviewStatus || data?.status || "Not Submitted";
      setcurrentMLRStatus(nextStatus);

      if (nextStatus === "Not Submitted") {
        setTabSelected(1);
      }
    };

    emitter.on("autoSync", handleMLRStatusUpdate);

    return () => {
      emitter.off("autoSync", handleMLRStatusUpdate);
    };
  }, [bannerId]);

  const getAssetDetails = (id) => {
    getSaveAssets(id, async (response, err, errorCode) => {
      const data = await response.data;
      if (err) {
      } else {
        setmarket(data.marketName);
        setisAnimated(data?.isAnimated);
      }
    });
  };

  function hasChanges(obj) {
    return !Object.values(obj).every(
      (value) => value === "No changes detected",
    );
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const status = await getLatestMLRStatus(bannerId);

        /**
         * BUG: https://indegene-cto.atlassian.net/browse/CSB-1661
         * 
         * This response line is commented because of this bug.
         * I attached video in jira for better understanding.
         */

        let response = await getAssetsDataTrackChanges(bannerId)
        
        if(!response || !response.data || (Array.isArray(response.data) && response.data.length === 0)){
          response = await getAssetsData(bannerId)
        }
        if (response && response?.data.length > 0) {
          setLoading(false);
          getAssetDetails(response?.data?.[0].assetId || "");

          const sortedAssets = response.data.sort(
            (a, b) =>
              (b.screenShots?.length || 0) - (a.screenShots?.length || 0),
          );

          setAssetData(sortedAssets);

          if (status !== "Not Submitted") {
            sortedAssets.forEach((element) => {
              let framesList = element.screenShots.length
                ? element.screenShots.map((img, index) => ({
                    id: index + 1,
                    time: img.time,
                    imgSrc: img.data || img?.oldImage || NO_PREVIEW_BASE64,
                    newImgSrc: img?.newImage || NO_PREVIEW_BASE64,
                    trackChangesNotes: img?.trackChanges?.textChanges,
                    completeTrackObject: img?.trackChanges || {},
                    description:
                      currentMLRStatus === "Not Submitted"
                        ? img?.description
                        : img?.description,
                    name: img.name || `Frame ${index + 1}`,
                    imgChanged: hasChanges(img?.trackChanges || {}),
                  }))
                : [
                    {
                      id: 1,
                      time: 0,
                      imgSrc: NO_PREVIEW_BASE64,
                      newImgSrc: NO_PREVIEW_BASE64,
                      name: "No Preview Available",
                    },
                  ];

              framesList.sort((a, b) => a.time - b.time);
              framesList.forEach((frame) =>
                handleSelectAll(frame.id, element.size),
              );
            });
          }

          const preferredSize = localStorage.getItem(`preferredRsdSize_${bannerId}`);

          const preferredAsset = preferredSize 
            ? sortedAssets.find((asset) => asset.size === preferredSize) 
            : null;

          const firstTabWithScreenshots = sortedAssets.find(
            (asset) => asset.screenShots.length > 0,
          );

          const defaultTab = 
            preferredAsset?.size ||
            firstTabWithScreenshots?.size ||
            sortedAssets[0]?.size ||
            "";

          localStorage.removeItem("preferredRsdSize");

          setActiveTab(defaultTab);
          setBannerName(
            sortedAssets.find((asset) => asset.size === defaultTab)
              ?.assetName || "Banner Preview",
          );
        } else {
          setLoading(false);
          setnoScreensShotsAvailable(true);
          toast.error(
            <div className="notificationText">
              {`Failed to fetch screenshots for current Veeva Document Number.`}
            </div>,
          );
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching asset data:", error);
      }
    };

    fetchData();

    return () => {};
  }, [bannerId]);

  const getFramesForActiveTab = () => {
    if (!assetData.length || !activeTab) return [];

    const activeAsset = assetData.find((asset) => asset.size === activeTab);
    if (!activeAsset) return [];

    let framesList = activeAsset.screenShots.length
      ? activeAsset.screenShots.map((img, index) => ({
          id: index + 1,
          time: img.time,
          imgSrc: img.data || img?.oldImage || NO_PREVIEW_BASE64,
          newImgSrc: img?.newImage || NO_PREVIEW_BASE64,
          trackChangesNotes: img?.trackChanges || {},
          completeTrackObject: img?.trackChanges || {},
          description:
            currentMLRStatus === "Not Submitted"
              ? img?.description
              : img?.description,

          name: img.name || `Frame ${index + 1}`,
          imgChanged: hasChanges(img?.trackChanges || {}),
        }))
      : [
          {
            id: 1,
            time: 0,
            imgSrc: NO_PREVIEW_BASE64,
            newImgSrc: NO_PREVIEW_BASE64,
            name: "No Preview Available",
          },
        ];
    return framesList.sort((a, b) => a.time - b.time);
  };

  const frames = getFramesForActiveTab();
  const handleSelect = (frameId) => {
    setSelectedFramesPerTab((prev) => {
      const newState = { ...prev };
      if (!newState[activeTab]) {
        newState[activeTab] = [];
      }
      if (newState[activeTab].includes(frameId)) {
        newState[activeTab] = newState[activeTab].filter(
          (id) => id !== frameId,
        );
        setTabDescriptions((prevDescriptions) => {
          const updatedDescriptions = { ...prevDescriptions };
          if (updatedDescriptions[activeTab]) {
            delete updatedDescriptions[activeTab][frameId];
            if (Object.keys(updatedDescriptions[activeTab]).length === 0) {
              delete updatedDescriptions[activeTab];
            }
          }
          return updatedDescriptions;
        });
        setTabTrackChanges((prevDescriptions) => {
          const updatedDescriptions = { ...prevDescriptions };
          if (updatedDescriptions[activeTab]) {
            delete updatedDescriptions[activeTab][frameId];
            if (Object.keys(updatedDescriptions[activeTab]).length === 0) {
              delete updatedDescriptions[activeTab];
            }
          }
          return updatedDescriptions;
        });
      } else {
        newState[activeTab] = [...newState[activeTab], frameId];
      }

      return newState;
    });
  };

  const handleDescription = (frameId, text) => {
    setTabDescriptions((prev) => {
      const newState = { ...prev };
      if (!newState[activeTab]) {
        newState[activeTab] = {};
      }
      newState[activeTab][frameId] = text;
      return newState;
    });
  };

  const handelTrackChange = (frameId, text) => {
    setTabTrackChanges((prev) => {
      const newState = { ...prev };
      if (!newState[activeTab]) {
        newState[activeTab] = {};
      }
      newState[activeTab][frameId] = text;
      return newState;
    });
  };

  const handleSelectAll = (frameId, tab) => {
    setSelectedFramesPerTab((prev) => {
      const newState = { ...prev };
      if (!newState[tab]) {
        newState[tab] = [];
      }
      if (newState[tab].includes(frameId)) {
        newState[tab] = newState[tab].filter((id) => id !== frameId);
        setTabDescriptions((prevDescriptions) => {
          const updatedDescriptions = { ...prevDescriptions };
          if (updatedDescriptions[tab]) {
            delete updatedDescriptions[tab][frameId];
            if (Object.keys(updatedDescriptions[tab]).length === 0) {
              delete updatedDescriptions[tab];
            }
          }
          return updatedDescriptions;
        });
        setTabTrackChanges((prevDescriptions) => {
          const updatedDescriptions = { ...prevDescriptions };
          if (updatedDescriptions[tab]) {
            delete updatedDescriptions[tab][frameId];
            if (Object.keys(updatedDescriptions[tab]).length === 0) {
              delete updatedDescriptions[tab];
            }
          }
          return updatedDescriptions;
        });
      } else {
        newState[tab] = [...newState[tab], frameId];
      }

      return newState;
    });
  };

  const handleEditClick = () => {
    setShowConfirmation(true);
  };

  const handleProceed = () => {
    setShowConfirmation(false);
    history.push(`/`);
  };

  const handleCancel = () => {
    setShowConfirmation(false);
  };

  const sendToHome = () => {
    window.location.replace("/");
  };

  const handleFinalize = () => {
    const isBannerDisabled = isDisabled({
      marketName: market,
      mlrStatus: currentMLRStatus,
    });
    if (isBannerDisabled) {
      toast.error(
        <div className="notificationText">
          {`You can't republish this banner because it is in the ${currentMLRStatus} state.`}
        </div>,
      );
      return;
    }
    const unselectedTabs = assetData.filter(
      (asset) =>
        !selectedFramesPerTab[asset.size] ||
        selectedFramesPerTab[asset.size].length === 0,
    );

    if (unselectedTabs.length > 0) {
      alert(
        `Please select at least one frame for: ${unselectedTabs
          .map((tab) => tab.size)
          .join(", ")}`,
      );
      return;
    }

    if (isAnimated) {
      setShowStaticModal(true);
    } else {
      handleStatic(false);
    }
  };

  const generateFinalPayload = (includeStaticImage) => {
    return assetData.map((asset) => {
      const selectedFramesForTab = selectedFramesPerTab[asset.size] || [];
      const framesForTab = asset.screenShots.length
        ? asset.screenShots.map((img, index) => ({
            id: index + 1,
            time: img.time,
            imgSrc: img?.data || img?.oldImage || NO_PREVIEW_BASE64,
            newImgSrc: img?.newImage || NO_PREVIEW_BASE64,
            name: img.name || `Frame ${index + 1}`,
            fileExtension: img.fileExtension,
            description: img?.description || "",
            trackChangesNotes: img?.trackChanges?.textChanges,
            completeTrackObject: img?.trackChanges || {},
            imgChanged: hasChanges(img?.trackChanges || {}),
          }))
        : [
            {
              id: 1,
              time: 0,
              imgSrc: NO_PREVIEW_BASE64,
              newImgSrc: NO_PREVIEW_BASE64,
              name: "No Preview Available",
            },
          ];

      return {
        name: asset.assetName,
        assetId: asset.assetId,
        size: asset.size,
        width: asset.width,
        height: asset.height,
        static: includeStaticImage,
        images: selectedFramesForTab
          .map((frameId) => {
            const frame = framesForTab.find((f) => f.id === frameId);
            if (!frame || !frame.imgSrc) {
              console.warn(`Frame data missing for frameId: ${frameId}`);
              return null;
            }
            return {
              image: frame.imgSrc,
              description: `<div>${
                tabDescriptions[asset.size]?.[frameId] ||
                frame?.description ||
                "No description"
              }</div>`,
              trackChanges: `${convertTextToBullets(
                tabTrackChanges[asset.size]?.[frameId],
              )}`,
              newImgSrc: frame.newImgSrc,
              name: frame.name || `image${frameId}.png`,
              time: frame.time,
              fileExtension: frame.fileExtension,
              imgChanged: frame?.imgChanged,
              completeTrackObject: frame?.completeTrackObject,
            };
          })
          .filter(Boolean),
      };
    });
  };

  const getBackupImageForAsset = (assetId) =>
    new Promise((resolve) => {
      getBackupImageSettings(assetId, (response, err) => {
        if (err) {
          // Backup images are optional and must not block the publish flow.
          resolve(null);
          return;
        }
        const { imageUrl } = extractBackupImageData(response);
        resolve(
          imageUrl
            ? {
                imageUrl,
              }
            : null,
        );
      });
    });

  const handleStatic = async (includeStaticImage) => {
    setShowStaticModal(false);
    setLoading(true);

    const backupImageByAssetId = {};

    const finalPayload = generateFinalPayload(includeStaticImage);
    const publishPayload = await Promise.all(
      finalPayload.map(async ({ assetId, name, images }) => {
        const backupImage = await getBackupImageForAsset(assetId) || null;
        backupImageByAssetId[assetId] = backupImage;
    
        return {
          assetId,
          name,
          screenShots: images.map(
            ({ time, name, description, trackChanges = "", fileExtension }) => ({
              time,
              name,
              description,
              trackChanges,
              fileExtension,
            }),
          ),
          backupImage, // One backup image for this banner size, or null
        };
      }),
    );

    if (finalPayload.every((payload) => payload.images.length === 0)) {
      setLoading(false);
      toast.error("No valid frames selected. Please try again.");
      return;
    }
    let mypayload = [...finalPayload].map((item) => {
      let scrollImage = item.images.filter((i) => i.time === 10000);
      let generalImage = item.images.filter((i) => i.time !== 10000);
      return {
        ...item,
        backupImage: backupImageByAssetId[item.assetId] || null,
        images: generalImage?.sort((a, b) => a.time - b.time),
        scrollImage,
      };
    });
    let statusDoc = currentMLRStatus === "Not Submitted";
    let finalHtml = await generateTrackHtml(mypayload, statusDoc);
    let trackHtml = await generateTrackChangesHtml(mypayload);

    try {

      let bannerName =
        assetData.length > 0 ? assetData[0].assetName : "Banner Export";

      let pdfPayload = {
        emailID: localStorage.getItem("userEmail"),
        currentUserName: localStorage.getItem("currentUserName"),
        name: bannerName,
        html: finalHtml,
        bannerId: bannerId,
        finalPayload,
      };
      const finalName = bannerName?.split("_")[0];

      const formDatatype = new FormData();
      formDatatype.append(
        "trackChangesHtml",
        currentMLRStatus !== "Not Submitted" ? trackHtml : null,
      );
      formDatatype.append("cleanHtml", finalHtml);
      formDatatype.append("cleanHtmlFilename", finalName);
      formDatatype.append(
        "trackChangesHtmlFilename",
        currentMLRStatus !== "Not Submitted" ? `${finalName}_track` : null,
      );
      formDatatype.append("assets", JSON.stringify(publishPayload));
      // formDatatype.append("backupImage", "https://d3vq2las3eydhs.cloudfront.net/ContentStudio/Banners/sample-e21be9e9-916e-4e59-ab6f-8ebe965d0731.png");

      veevaPublish(formDatatype, bannerId, (response, err) => {
        setLoading(false);
        if (response.status === 200) {
          toast.success(
            <div className="notificationText">
              Publish is in progress. An email notification will be sent to you
              once the PDF has been published.
            </div>,
          );

          history.push("/");
        } else {
          toast.error(
            <div className="notificationText">
              {`Failed to publish the PDF file: ${
                err?.data?.debugMessage || ""
              }`}
            </div>,
          );
        }
      });
    } catch (error) {
      setLoading(false);
      toast.error("Failed to generate PDF: " + error.message);
    }
  };

  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [activeTab]);

  const handleTabChange = (event, newValue) => {
    setDescriptions((prev) => ({
      ...prev,
      [activeTab]: { ...(prev[activeTab] || {}) },
    }));

    setActiveTab(newValue);
    const selectedAsset = assetData.find((asset) => asset.size === newValue);
    if (selectedAsset) {
      setBannerName(selectedAsset.assetName || "Banner Preview");
    }
  };

  const journeyImageSrc =
    currentMLRStatus === "Not Submitted" ? RSDImageOTC : RSDImageDoneOTC;

  if (loading || !activeTab) {
    return (
      <>
        <div className="modal-backdrop fade show"> </div>
        <CircularProgress size="30px" className="customLoader" />{""}
      </>
    );
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          position: "fixed",
          width: "100%",
          top: 0,
        }}
      >
        <BannerPreviewHeader
          additionalProps={additionalProps}
          bannerName={bannerName}
          bannerType={isAnimated ? "Animated" : "Static"}
        />
        <div className="middle-pannel-header-module">
          <img
            className="journeyBarImageModuleRSD"
            src={journeyImageSrc}
            alt="RSD Journey"
          />
        </div>

        {
          <div className="middle-pannel-header4 bg-white banner-preview-size-tabs">
            <Tabs
              className="banner-preview-size-tabs__tabs"
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              TabIndicatorProps={{ style: { backgroundColor: "#203662" } }}
            >
              {assetData.map((asset) => (
                <Tab
                  className="banner-preview-size-tabs__tab"
                  key={asset.assetId}
                  label={asset.size}
                  value={asset.size}
                />
              ))}
            </Tabs>
          </div>
        }

        {!noScreensShotsAvailable && (
          <div className="middle-pannel-header3 bg-white">
            <div className="rsd-container">
              <div className="rsd-content">
                <div className="rsd-content-boder">
                  <div
                    onClick={() => setTabSelected(1)}
                    className={
                      tabSelected === 1 ? "rsd-div rsdbgColorClass" : "rsd-div"
                    }
                  >
                    RSD Preview
                  </div>
                  {/* Do not remove */}
                  <div
                    onClick={
                      currentMLRStatus === "Not Submitted"
                        ? () => {}
                        : () => setTabSelected(2)
                    }
                    style={
                      currentMLRStatus === "Not Submitted"
                        ? { cursor: "not-allowed" }
                        : {}
                    }
                    className={
                      tabSelected === 2
                        ? "rsdcontent-div rsdbgColorClass"
                        : "rsdcontent-div"
                    }
                  >
                    RSD Preview with track changes
                  </div>
                </div>
              </div>

              <p className="rsd-description">
                Select the required frames under the "RSD Preview" tab to
                preview the respective "RSD Preview with Track Changes" and then
                "Publish".{" "}
                <span style={{ fontWeight: "bold", color: "#000" }}>
                  Disclaimer
                </span>{" "}
                : Track changes Summary is generated by AI and might not be
                fully accurate. Please review carefully.
              </p>
            </div>
          </div>
        )}

        {noScreensShotsAvailable ? (
          <h4
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            {"No Screenshots available for this Veeva Document Number."}
          </h4>
        ) : (
          <Container
            fluid
            ref={scrollRef}
            className="customScrollBar"
            style={{
              paddingLeft: "25px",
              paddingTop: "21px",
              backgroundColor: "#F4F6F9",
              flex: "1",
              overflowY: "auto",
            }}
          >
            <div className="bg-white p-3">
              {frames.length > 0 &&
                frames.map((frame) => (
                  <Frame
                    key={`${activeTab}-${frame.id}`}
                    frameId={frame.id}
                    time={frame.time}
                    isSelected={
                      selectedFramesPerTab[activeTab]?.includes(frame.id) ||
                      false
                    }
                    onSelect={handleSelect}
                    description={
                      tabDescriptions[activeTab]?.[frame.id] ||
                      frame?.description
                    }
                    onDescriptionChange={handleDescription}
                    onTrackChange={handelTrackChange}
                    imgSrc={frame.imgSrc}
                    newImgSrc={frame.newImgSrc}
                    width={activeTab.split("×")[0].trim()}
                    activeTab={activeTab}
                    currentMLRStatus={currentMLRStatus}
                    tabSelected={tabSelected}
                    imgChanged={frame.imgChanged}
                    trackChangesNotes={
                      tabTrackChanges[activeTab]?.[frame.id] ||
                      frame?.trackChangesNotes
                    }
                  />
                ))}
            </div>
          </Container>
        )}

        {!noScreensShotsAvailable && (
          <footer
            className="bg-white d-flex justify-content-between align-items-center px-3"
            style={{ height: "60px", boxShadow: "1px -3px 10px #00000012" }}
          >
            <div>
              <button
                className="btn btn-link"
                style={{ color: "#203662", fontSize: "12px", display: "none" }}
                onClick={handleEditClick}
              >
                EDIT
              </button>
            </div>
            <div className="d-flex align-items-center" style={{ gap: "24px" }}>
              <button
                className="btn btn-link"
                disabled={false}
                style={{
                  color: "#203662",
                  fontSize: "12px",
                  textDecoration: "none",
                }}
                onClick={sendToHome}
              >
                CANCEL
              </button>

              <button
                className="primary-button"
                onClick={handleFinalize}
                disabled={
                  assetData.length === 0 ||
                  assetData.some(
                    (asset) =>
                      !selectedFramesPerTab[asset.size] ||
                      selectedFramesPerTab[asset.size].length === 0,
                  )
                }
              >
                PUBLISH
              </button>
            </div>
          </footer>
        )}
        <BannerConfirmationModal
          showConfirmation={showConfirmation}
          handleCancel={handleCancel}
          handleProceed={handleProceed}
        />
        <BannerStaticConfirmation
          showStaticModal={showStaticModal}
          handleCancel={() => setShowStaticModal(false)}
          handleStatic={handleStatic}
        />

        {loading && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress size="30px" className="customLoader" />{" "}
          </>
        )}
      </div>
    </>
  );
};

export default PreviewBanner;
